export const RELATION_OPTIONS = [
  {
    label: '全部',
    value: null
  },
  {
    label: '未关联',
    value: 0
  },
  {
    label: '已关联',
    value: 1
  }
]